module.exports = __webpack_public_path__ + "static/media/r45.47d05ff2.jpg";